import React, { createContext, useContext, useState, useCallback } from 'react';

const LightboxContext = createContext({
    isOpen: false,
    activeImage: null,
    openLightbox: () => {},
    closeLightbox: () => {},
});

export const LightboxProvider = ({ children }) => {
    const [activeImage, setActiveImage] = useState(null);

    const openLightbox = useCallback((src, title = '', subtitle = '') => {
        if (!src) return;
        setActiveImage({
            src,
            title: typeof title === 'string' ? title : '',
            subtitle: typeof subtitle === 'string' ? subtitle : '',
        });
    }, []);

    const closeLightbox = useCallback(() => {
        setActiveImage(null);
    }, []);

    return (
        <LightboxContext.Provider
            value={{
                isOpen: !!activeImage,
                activeImage,
                openLightbox,
                closeLightbox,
            }}
        >
            {children}
        </LightboxContext.Provider>
    );
};

export const useLightbox = () => useContext(LightboxContext);
